import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import CompanyGuard from '@src/components/guard/CompanyGuard';
import EventsShow from '@src/features/company/events/EventsShow';
import CompanyDefaultLayout from '@src/layouts/company/CompanyDefaultLayout';
import { useState } from 'react';

function CompanyEventsShow() {
  const [feature, setFeature] = useState('');
  const [description, setDescription] = useState('');

  return (
    <CompanyGuard canService={[SERVICE.ENTERPRISE_PORTAL]}>
      <CompanyDefaultLayout pageName='events'>
        <CommonHelmet
          feature={feature}
          description={description}
        />
        <EventsShow
          setFeature={setFeature}
          setDescription={setDescription}
        />
      </CompanyDefaultLayout>
    </CompanyGuard>
  );
}

export default CompanyEventsShow;
